import { ApplicationV1Enum } from "@/api-schema-enums";
import { Checkbox } from "@/components/ui/checkbox";
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import i18next from "i18next";
import { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { z } from "zod";

export const formSchema = z.object({
  azureClientUuid: z.uuid({
    message: i18next.t("ram:ThisIsNotAValidUUID"),
  }),
  isV1Application: z.enum(ApplicationV1Enum),
});

export type formSchemaType = z.infer<typeof formSchema>;

type AppRoleFormFieldsType = {
  formControl: Control<formSchemaType>;
};

export function ApplicationFormFields({ formControl }: AppRoleFormFieldsType) {
  const { t } = useTranslation(["ram", "common"]);

  return (
    <div className="space-y-6">
      <FormField
        control={formControl}
        name="azureClientUuid"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t("ram:AzureClientUUID")}</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormDescription>{t("ram:TheUniqueIdentifierOfTheRegisteredApplicationInAzureAD")}</FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={formControl}
        name="isV1Application"
        render={({ field }) => (
          <FormItem className="flex flex-row items-start space-y-0 space-x-3">
            <FormControl>
              <Checkbox
                checked={field.value === ApplicationV1Enum.IsV1}
                onCheckedChange={(checked) => {
                  field.onChange(checked ? ApplicationV1Enum.IsV1 : ApplicationV1Enum.IsNotV1);
                }}
              />
            </FormControl>
            <div className="space-y-2 leading-none">
              <FormLabel>{t("ram:V1Application")}</FormLabel>
              <FormDescription>{t("ram:IndicatesWhetherItIsAV1Application")}</FormDescription>
            </div>
          </FormItem>
        )}
      />
    </div>
  );
}
